/*
  FAQ one column — collapse the whole list behind a single toggle.

  Used by the "Title left, toggle right" header layout. The list starts open
  and only closes once someone asks it to, so the questions are present and
  readable if this script never runs.

  Mirrors how a single FAQ item behaves: a class flips the display, with
  aria-expanded on the button driving the chevron.
*/
(function () {
  'use strict';

  var SELECTOR = '[data-faq-collapse-all]';

  function init(scope) {
    var buttons = (scope || document).querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(buttons, function (btn) {
      if (btn.dataset.faqCollapseReady === '1') return;
      btn.dataset.faqCollapseReady = '1';

      var wrapper = document.getElementById(btn.getAttribute('aria-controls'));
      if (!wrapper) return;

      btn.addEventListener('click', function () {
        var collapsed = wrapper.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* Theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
